import { render } from "./Trabajo.vue?vue&type=template&id=5dca5429"
import script from "./Trabajo.vue?vue&type=script&lang=js"
export * from "./Trabajo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__